import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import SvgIcon from '../SvgIcon.js';
var IconIcDiscordNotificationIcon = props => /*#__PURE__*/
// eslint-disable-next-line react/jsx-props-no-spreading
React.createElement(SvgIcon, _extends({}, props, {
  viewBox: "0 0 40 40",
  iconname: "IconIcDiscordNotificationIcon"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#pathTo_Svg__Clip0_6001_783)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#pathTo_Svg__Clip1_6001_783)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M23.8 0H4.2C1.8804 0 0 1.8804 0 4.2V23.8C0 26.1196 1.8804 28 4.2 28H23.8C26.1196 28 28 26.1196 28 23.8V4.2C28 1.8804 26.1196 0 23.8 0Z",
  fill: "#5865F2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.7285 8.02618C18.6583 7.54241 17.5442 7.19058 16.3861 7C16.2395 7.26387 16.0782 7.60105 15.961 7.87958C14.7295 7.68901 13.4835 7.68901 12.2521 7.87958C12.1201 7.57173 11.9735 7.27853 11.8123 7C10.6542 7.19058 9.52536 7.54241 8.46986 8.04084C6.35887 11.1927 5.78714 14.2565 6.06567 17.2911C7.31175 18.2147 8.68976 18.9183 10.1704 19.3581C10.5076 18.9037 10.8007 18.4346 11.05 17.9361C10.5662 17.7602 10.1117 17.5403 9.67196 17.2764C9.78923 17.1885 9.89185 17.1005 10.0091 17.0126C12.6039 18.244 15.6238 18.244 18.2186 17.0126C18.3358 17.1005 18.4384 17.1885 18.5557 17.2764C18.1159 17.5403 17.6468 17.7602 17.1631 17.9361C17.4123 18.4346 17.7055 18.9037 18.0426 19.3581C19.5233 18.9037 20.9159 18.2147 22.1473 17.2911C22.4699 13.7728 21.561 10.7236 19.7285 8.02618ZM11.4018 15.4147C10.5955 15.4147 9.95049 14.6817 9.95049 13.7874C9.95049 12.8932 10.5955 12.1455 11.4018 12.1455C12.2227 12.1455 12.8678 12.8785 12.8678 13.7874C12.8531 14.6817 12.2227 15.4147 11.4018 15.4147ZM16.7966 15.4147C15.9903 15.4147 15.3453 14.6817 15.3453 13.7874C15.3453 12.8932 15.9903 12.1455 16.7966 12.1455C17.6175 12.1455 18.2625 12.8785 18.2479 13.7874C18.2332 14.6963 17.6028 15.4147 16.7966 15.4147Z",
  fill: "white"
})), /*#__PURE__*/React.createElement("rect", {
  x: "20",
  y: "20",
  width: "20",
  height: "20",
  rx: "2",
  fill: "#F57138"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.8132 23.8882C32.1235 23.9713 32.3096 24.2828 32.229 24.5839L32.0725 25.1677C33.9075 25.9428 34.9465 27.926 34.4313 29.8486L33.8178 32.1384L34.3072 33.1575C34.7268 34.0312 33.9175 34.9699 32.9649 34.7147L25.403 32.6885C24.4504 32.4332 24.2189 31.2156 25.019 30.6688L25.9525 30.0309L26.566 27.7412C27.0812 25.8186 28.9723 24.6207 30.9489 24.8667L31.1054 24.2828C31.186 23.9817 31.503 23.805 31.8132 23.8882Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.6435 35.0121C26.527 34.7647 26.4537 34.4904 26.4272 34.2034L29.9633 35.1509C29.797 35.3862 29.5963 35.5871 29.3717 35.7431C29.1358 35.9069 28.8781 36.0179 28.6133 36.0698C28.3486 36.1218 28.0819 36.1135 27.8286 36.0457C27.5753 35.9778 27.3402 35.8516 27.1369 35.6742C26.9335 35.4969 26.7659 35.2719 26.6435 35.0121Z",
  fill: "white"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "pathTo_Svg__Clip0_6001_783"
}, /*#__PURE__*/React.createElement("rect", {
  width: "40",
  height: "40",
  fill: "white"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "pathTo_Svg__Clip1_6001_783"
}, /*#__PURE__*/React.createElement("rect", {
  width: "28",
  height: "28",
  fill: "white"
}))));
export { IconIcDiscordNotificationIcon as default };
//# sourceMappingURL=IconIcDiscordNotificationIcon.js.map